/*
 * jQuery doTimeout: Like setTimeout, but better! - v1.0 - 3/3/2010
 * http://benalman.com/projects/jquery-dotimeout-plugin/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function($){var a={},c="doTimeout",d=Array.prototype.slice;$[c]=function(){return b.apply(window,[0].concat(d.call(arguments)))};$.fn[c]=function(){var f=d.call(arguments),e=b.apply(this,[c+f[0]].concat(f));return typeof f[0]==="number"||typeof f[1]==="number"?this:e};function b(l){var m=this,h,k={},g=l?$.fn:$,n=arguments,i=4,f=n[1],j=n[2],p=n[3];if(typeof f!=="string"){i--;f=l=0;j=n[1];p=n[2]}if(l){h=m.eq(0);h.data(l,k=h.data(l)||{})}else{if(f){k=a[f]||(a[f]={})}}k.id&&clearTimeout(k.id);delete k.id;function e(){if(l){h.removeData(l)}else{if(f){delete a[f]}}}function o(){k.id=setTimeout(function(){k.fn()},j)}if(p){k.fn=function(q){if(typeof p==="string"){p=g[p]}p.apply(m,d.call(n,i))===true&&!q?o():e()};o()}else{if(k.fn){j===undefined?e():k.fn(j===false);return true}else{e()}}}})(jQuery);

/*!
 * @preserve
 *
 * Readmore.js jQuery plugin
 * Author: @jed_foster
 * Project home: http://jedfoster.github.io/Readmore.js
 * Licensed under the MIT license
 *
 * Debounce function from http://davidwalsh.name/javascript-debounce-function
 */
!function(t){"function"==typeof define&&define.amd?define(["jquery"],t):"object"==typeof exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){"use strict";function e(t,e,i){var o;return function(){var n=this,a=arguments,s=function(){o=null,i||t.apply(n,a)},r=i&&!o;clearTimeout(o),o=setTimeout(s,e),r&&t.apply(n,a)}}function i(t){var e=++h;return String(null==t?"rmjs-":t)+e}function o(t){var e=t.clone().css({height:"auto",width:t.width(),maxHeight:"none",overflow:"hidden"}).insertAfter(t),i=e.outerHeight(),o=parseInt(e.css({maxHeight:""}).css("max-height").replace(/[^-\d\.]/g,""),10),n=t.data("defaultHeight");e.remove();var a=o||t.data("collapsedHeight")||n;t.data({expandedHeight:i,maxHeight:o,collapsedHeight:a}).css({maxHeight:"none"})}function n(t){if(!d[t.selector]){var e=" ";t.embedCSS&&""!==t.blockCSS&&(e+=t.selector+" + [data-readmore-toggle], "+t.selector+"[data-readmore]{"+t.blockCSS+"}"),e+=t.selector+"[data-readmore]{transition: height "+t.speed+"ms;overflow: hidden;}",function(t,e){var i=t.createElement("style");i.type="text/css",i.styleSheet?i.styleSheet.cssText=e:i.appendChild(t.createTextNode(e)),t.getElementsByTagName("head")[0].appendChild(i)}(document,e),d[t.selector]=!0}}function a(e,i){this.element=e,this.options=t.extend({},r,i),n(this.options),this._defaults=r,this._name=s,this.init(),window.addEventListener?(window.addEventListener("load",c),window.addEventListener("resize",c)):(window.attachEvent("load",c),window.attachEvent("resize",c))}var s="readmore",r={speed:100,collapsedHeight:200,heightMargin:16,moreLink:'<a href="#">Read More</a>',lessLink:'<a href="#">Close</a>',embedCSS:!0,blockCSS:"display: block; width: 100%;",startOpen:!1,blockProcessed:function(){},beforeToggle:function(){},afterToggle:function(){}},d={},h=0,c=e(function(){t("[data-readmore]").each(function(){var e=t(this),i="true"===e.attr("aria-expanded");o(e),e.css({height:e.data(i?"expandedHeight":"collapsedHeight")})})},100);a.prototype={init:function(){var e=t(this.element);e.data({defaultHeight:this.options.collapsedHeight,heightMargin:this.options.heightMargin}),o(e);var n=e.data("collapsedHeight"),a=e.data("heightMargin");if(e.outerHeight(!0)<=n+a)return this.options.blockProcessed&&"function"==typeof this.options.blockProcessed&&this.options.blockProcessed(e,!1),!0;var s=e.attr("id")||i(),r=this.options.startOpen?this.options.lessLink:this.options.moreLink;e.attr({"data-readmore":"","aria-expanded":this.options.startOpen,id:s}),e.after(t(r).on("click",function(t){return function(i){t.toggle(this,e[0],i)}}(this)).attr({"data-readmore-toggle":s,"aria-controls":s})),this.options.startOpen||e.css({height:n}),this.options.blockProcessed&&"function"==typeof this.options.blockProcessed&&this.options.blockProcessed(e,!0)},toggle:function(e,i,o){o&&o.preventDefault(),e||(e=t('[aria-controls="'+this.element.id+'"]')[0]),i||(i=this.element);var n=t(i),a="",s="",r=!1,d=n.data("collapsedHeight");n.height()<=d?(a=n.data("expandedHeight")+"px",s="lessLink",r=!0):(a=d,s="moreLink"),this.options.beforeToggle&&"function"==typeof this.options.beforeToggle&&this.options.beforeToggle(e,n,!r),n.css({height:a}),n.on("transitionend",function(i){return function(){i.options.afterToggle&&"function"==typeof i.options.afterToggle&&i.options.afterToggle(e,n,r),t(this).attr({"aria-expanded":r}).off("transitionend")}}(this)),t(e).replaceWith(t(this.options[s]).on("click",function(t){return function(e){t.toggle(this,i,e)}}(this)).attr({"data-readmore-toggle":n.attr("id"),"aria-controls":n.attr("id")}))},destroy:function(){t(this.element).each(function(){var e=t(this);e.attr({"data-readmore":null,"aria-expanded":null}).css({maxHeight:"",height:""}).next("[data-readmore-toggle]").remove(),e.removeData()})}},t.fn.readmore=function(e){var i=arguments,o=this.selector;return e=e||{},"object"==typeof e?this.each(function(){if(t.data(this,"plugin_"+s)){var i=t.data(this,"plugin_"+s);i.destroy.apply(i)}e.selector=o,t.data(this,"plugin_"+s,new a(this,e))}):"string"==typeof e&&"_"!==e[0]&&"init"!==e?this.each(function(){var o=t.data(this,"plugin_"+s);o instanceof a&&"function"==typeof o[e]&&o[e].apply(o,Array.prototype.slice.call(i,1))}):void 0}});


var pInfScrLoading = false;
var pInfScrDelay = 200;

function ScrollExecute() {
  if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
    scrollNode = $('.more').last();    
    scrollURL = $('.more a').last().attr("href");
    if(!pInfScrLoading && scrollNode.length > 0 && scrollNode.css('display') != 'none') {
      $.ajax({
        type: 'GET',
        url: scrollURL,
        beforeSend: function() {
          pInfScrLoading = true;
          //scrollNode.clone().empty().addClass("loading").insertAfter(scrollNode).append('<img src=\"//www.romancewasborn.com/cdn/shop/t/41/assets/ajax-loader.gif?v=21344\" />');
          scrollNode.clone().empty().addClass("loading").insertAfter(scrollNode).append('<p>Loading more products</p>');
          scrollNode.hide();
        },
        success: function(data) {
          // remove loading feedback
          $(".loading").remove();
          var filteredData = $(data).find(".grid--collection");
          filteredData.insertBefore( $("#product-list-foot") ); 
          pInfScrLoading = false;
        },
        dataType: "html"
      });
    }
  }
}

$(document).ready(function () {


if($('body').hasClass('template-product')){

   if (window.innerWidth > 768) {
      var sidebar = new StickySidebar('.grid--single-productmeta', {
        topSpacing: 20,
        bottomSpacing: 20,
        containerSelector: '.grid--single-product',
        innerWrapperSelector: '.product-single__meta'
      });

       // Add event listener to trigger the updateSticky function
      document.querySelectorAll('.collapsible-trigger-btn').forEach(function(button) {
          button.addEventListener('click', function() {
              sidebar.updateSticky();
          });
      });
     

   }
  
    /*
    var dotButtons = document.querySelectorAll(".product__photos_scroll .slick-dots button");
  
      dotButtons.forEach(function(button, index) {
          button.addEventListener("click", function() {
              var trackElements = document.querySelectorAll(".product__photos_scroll .slick-track .slick-slide");
               console.log(index);
              var targetElement = trackElements[index];
              console.log(targetElement);
              targetElement.scrollIntoView({ behavior: "smooth" });
          });
      });



     var fixedDiv = document.querySelector(".product__photo-dots");
    var container = document.querySelector(".product__photos_scroll");
  
    var debounceTimeout;

    function debounce(func, delay) {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(func, delay);
    }

    window.addEventListener("scroll", function() {
        debounce(function() {
            if (window.innerWidth > 768) {
            var containerRect = container.getBoundingClientRect();
            var fixedDivRect = fixedDiv.getBoundingClientRect();

            // Calculate the distance of the fixed div from the top and bottom of the container
            var distanceFromTop = fixedDivRect.top - containerRect.top;
            var distanceFromBottom = containerRect.bottom - fixedDivRect.bottom;

            // Hide the fixed div when it gets within 200 pixels of the end or top of the container
            if (distanceFromBottom <= 200 || distanceFromTop <= 0) {
                fixedDiv.style.display = "none";
            } else {
                fixedDiv.style.display = "block";
            }
            }
        }, 200); // Adjust the delay as needed
    });
    */

  
}
  

  if($('body').hasClass('template-collection')){
    $(window).scroll(function(){
    $.doTimeout( 'scroll', pInfScrDelay, ScrollExecute);
    if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      pInfScrDelay = 200;
    }
  });
  }

  if($('body').hasClass('storytellingitem')){
    $('.storytellingitem #fullpage').fullpage({
      licenseKey: '27A3B9BC-1D0C4235-B3560741-16EA4E80',
      autoScrolling: false,
      fitToSection: false,
      slidesNavigation: true,
      loopHorizontal: false
    });

    $('.storytellingitem .downScroll, .storytellingitem .shopCollectionTitle').on('click', function() {  
      $('html, body').animate({
        	scrollTop: $("#shopthecollection").offset().top - 50
      }, 300);
      return false;
    });
  }
    
  
  /* Campaign page */
  $('.template-collection .rte.summary-text').readmore({
    speed: 300,
    collapsedHeight: 103,
    embedCSS: true,
    blockCSS: 'display: block; width: 100%; border-bottom:0; margin-bottom:5px;',
    lessLink: '<p><a href="#">less</a></p>',
    moreLink: '<p><a href="#">more</a></p>'
  });
  
   /* Campaign page */
  $('.page-campaign .rte.summary-text .campaign-summary-text').readmore({
    speed: 300,
    collapsedHeight: 153,
    embedCSS: true,
    blockCSS: 'display: block; width: 100%; border-bottom:0; margin-bottom:5px;',
    lessLink: '<p><a href="#">less</a></p>',
    moreLink: '<p><a href="#">more</a></p>'
  });
  
  /* Campaign page */
  $('.product-single__meta .rte.summary-text').readmore({
    speed: 300,
    collapsedHeight: 105,
    embedCSS: true,
    blockCSS: 'display: block; width: 100%; border-bottom:0; margin-bottom:5px;',
    lessLink: '<p><a href="#">read less</a></p>',
    moreLink: '<p><a href="#">read more</a></p>'
  });
  
  
  $(".page-campaign .rte.summary-text .campaign-summary-text").each(function(){
    if ($.trim($(this).text()) == ""){
      $(this).remove();
    } 
  });

  $('body').on('click', '.view-campaign-video', function(evt) {
    if ($('.page-campaign .summary-text').hasClass("has-video")){
      $('.page-campaign .summary-text').removeClass('has-video');
      $('.view-campaign-video').text('view campaign video');
    }
    else{
      $('.page-campaign .summary-text').addClass('has-video');
      $('.view-campaign-video').text('hide campaign video');
    }
    return true;
  });

  function slickify(){
    $('.featured-campaign-slider').slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 480,
          settings: "unslick"
        }
      ]
    });
  }

  slickify();
  
  $(window).resize(function(){
    var $windowWidth = $(window).width();
    if ($windowWidth > 480) {
      slickify();   
    }
  });
  
  // Home page + Featured collection sider
  $('.featured-collection-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }
      ]
  });
  
  // slick on mobile
      function slick_on_mobile(slider, settings){
        $(window).on('load resize', function() {
          if ($(window).width() > 767) {
            if (slider.hasClass('slick-initialized')) {
              slider.slick('unslick');
            }
            return
          }
          if (!slider.hasClass('slick-initialized')) {
            return slider.slick(settings);
          }
        });
      };
  
  // Product page slider
      $slick_slider = $('.product__main-photos .mobile-slider');
      settings_slider = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        adaptiveHeight: true,
        centerMode: false
        // more settings
      }
    /*   slick_on_mobile( $slick_slider, settings_slider); */

});

var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("div");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("div");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
        /* When an item is clicked, update the original select box,
        and the selected item: */
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            console.log(i);
            s.selectedIndex = i;
            if ("createEvent" in document) {
              var evt = document.createEvent("HTMLEvents");
              evt.initEvent("change", false, true);
              s.dispatchEvent(evt);
            }
            else {
              s.fireEvent("onchange");
            }
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });

}



function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);

